import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import { requestNotificationPermission } from "../utils/notifications";
import Lottie from "lottie-react";
import capsuleAnim from "../assets/capsule.json";
import stethoscopeAnim from "../assets/stethoscope.json";
import supplementAnim from "../assets/supplements.json";
import heartAnim from "../assets/Giving Heart, Heart Animation.json";
import beautyAnim from "../assets/Beauty.json";
import Swal from "sweetalert2";
import MedicineTypeSelector from "../components/MedicineTypeSelector";
import { BsHeadset } from "react-icons/bs";
import { FaUserDoctor } from "react-icons/fa6";

import comingSoonAnim from "../assets/coming-soon.json";



function CustomerDashboard() {
  const [user, setUser] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [pharmacistCalls, setPharmacistCalls] = useState([]);
  const [adminPhone, setAdminPhone] = useState("");
const [menuOpen, setMenuOpen] = useState(false);
const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();

  // ================= LOAD DATA =================
  useEffect(() => {
    loadUser();
    loadUnreadCount();

    axios.get("/support/pharmacists/")
      .then(res => setPharmacistCalls(res.data))
      .catch(() => setPharmacistCalls([]));

    axios.get("/admin/emergency-contact/get/")
      .then(res => setAdminPhone(res.data.phone))
      .catch(() => setAdminPhone(""));
  }, []);

  const loadUser = async () => {
    try {
      const res = await axios.get("/user-info/");
      setUser(res.data);
    } catch (err) {
      console.error(err);
    }
  };



useEffect(() => {
  fetchCartCount();
}, []);

const fetchCartCount = async () => {
  try {
    const res = await axios.get("/cart/");
    console.log("CART DATA:", res.data);

    if (Array.isArray(res.data)) {
      // quantity based count
      const total = res.data.reduce((sum, item) => sum + (item.quantity || 1), 0);
      setCartCount(total);
    } else if (res.data.items) {
      setCartCount(res.data.items.length);
    } else if (res.data.cart_items) {
      setCartCount(res.data.cart_items.length);
    } else {
      setCartCount(0);
    }

  } catch (err) {
    console.error("Cart fetch error", err);
  }
};







  const loadUnreadCount = async () => {
    try {
      const res = await axios.get("/notifications/unread-count/");
      setUnreadCount(res.data.unread || 0);
    } catch {}
  };

async function handleLogout() {
  const result = await Swal.fire({
    title: "Logout?",
    text: "Do you want to logout?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#0284C7",
    cancelButtonColor: "#aaa",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel"
  });

  if (result.isConfirmed) {
    localStorage.clear();
    navigate("/", { replace: true });
  }
}

  useEffect(() => {
    if (user?.role === "customer") {
      requestNotificationPermission();
    }
  }, [user]);

  return (
    <div style={styles.page}>

      {/* HEADER */}
      <div style={styles.header}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div onClick={()=>setMenuOpen(true)} style={styles.menuIcon}>
  ☰
</div>
          <div>
            <p style={styles.welcome}>WELCOME BACK</p>
            <h3 style={styles.name}>
              {user?.name?.trim() ? user.name : user?.phone}
            </h3>
          </div>
        </div>

        <div style={{ display: "flex", gap: 15 }}>
          <div onClick={() => navigate("/notifications")} style={{ position: "relative", ...styles.icon }}>
            🔔
            {unreadCount > 0 && <span style={styles.badge}>{unreadCount}</span>}
          </div>

          
       <div onClick={() => navigate("/cart")} style={{ position: "relative", ...styles.icon }}>
  🛒
  {cartCount > 0 && (
    <span style={styles.badge}>{cartCount}</span>
  )}
</div>
        </div>
      </div>

    {menuOpen && (
  <div style={styles.overlay} onClick={()=>setMenuOpen(false)}>
    <div style={styles.drawer} onClick={(e)=>e.stopPropagation()}>
      
      <p onClick={()=>navigate("/profile")}>👤 Profile</p>
      <p onClick={()=>navigate("/orders")}>📦 Orders</p>
      
     

<p onClick={()=>navigate("/requested-medicines")}>📄 Requested Medicine</p>
<p
  style={styles.menuItem}
  onMouseEnter={(e)=>e.target.style.background="#1f2937"}
  onMouseLeave={(e)=>e.target.style.background="transparent"}
  onClick={() => window.open(
    "https://www.google.com/maps/dir/?api=1&destination=28.329481,79.397409",
    "_blank"
  )}
>
📍 Locate Our Store
</p>


 <p onClick={()=>navigate("/refund-cancellation-policy")}>📄 Refund & Cancellation Policy</p>

























<p onClick={() => {
  setMenuOpen(false);
  setTimeout(() => {
    handleLogout();
  }, 200);
}}>
  🚪 Logout
</p>
    </div>
  </div>
)} 	














  <div style={styles.banner}>
      <center>
  <h2
    style={{
      margin: 0,
      fontSize: 32,
      fontWeight: 800
    }}
  >
     PharmaHelp
  </h2>

  <p
    style={{
      marginTop: 6,
      opacity: 0.9,
      fontSize: 14
    }}
  >
    Your Trusted Online Pharmacy
  </p>

  <div style={{ marginTop: 12 }}>
    ⚡ Fast Delivery in Bareilly
  </div>

  <div style={{ marginTop: 6 }}>
    🎁 Up to 70% OFF • ✅ Genuine Products
  </div>
</center>

      </div>





















      {/* CATEGORIES */}
      <div style={styles.grid}>
        <div
  style={styles.card}
  onClick={async () => {
  const result = await Swal.fire({
    title: "Choose Medicine Type",

    html: `
      <div style="display:flex;flex-direction:column;gap:15px;margin-top:20px;">

        <div id="genericBtn"
          style="
            background:linear-gradient(135deg,#16a34a,#22c55e);
            padding:18px;
            border-radius:18px;
            color:white;
            cursor:pointer;
            text-align:left;
            box-shadow:0 5px 15px rgba(0,0,0,0.15);
          ">

          <div style="font-size:20px;font-weight:bold;">
            💊 Generic Medicines
          </div>

          <div style="margin-top:5px;font-size:14px;opacity:0.9;">
            Affordable alternatives
          </div>

        </div>

        <div id="brandedBtn"
          style="
            background:linear-gradient(135deg,#2563eb,#4f46e5);
            padding:18px;
            border-radius:18px;
            color:white;
            cursor:pointer;
            text-align:left;
            box-shadow:0 5px 15px rgba(0,0,0,0.15);
          ">

          <div style="font-size:20px;font-weight:bold;">
            🏥 Branded / Ethical
          </div>

          <div style="margin-top:5px;font-size:14px;opacity:0.9;">
            Prescribed brands
          </div>

        </div>

      </div>
    `,

    showConfirmButton: false,
    width: 380,
    background: "#ffffff",
    borderRadius: 25,

    didOpen: () => {

      document.getElementById("genericBtn")
        .addEventListener("click", () => {
          Swal.close();
          navigate("/generic-medicines");
        });

      document.getElementById("brandedBtn")
        .addEventListener("click", () => {
          Swal.close();
          navigate("/products");
        });

    }
  });
}}
  onMouseEnter={(e)=>e.currentTarget.style.transform="scale(1.05)"}
  onMouseLeave={(e)=>e.currentTarget.style.transform="scale(1)"}
>
    <div style={{ display:"flex", justifyContent:"center" }}>
    <Lottie 
      animationData={capsuleAnim} 
      style={{ height: 80,  background:"transparent" }} 
    />
  </div>
<p style={styles.cardText}>Shop Medicines</p>







</div>
        
<div
  style={styles.card}
  onClick={() => navigate("/shop-surgical")}
  onMouseEnter={(e)=>e.currentTarget.style.transform="scale(1.05)"}
  onMouseLeave={(e)=>e.currentTarget.style.transform="scale(1)"}
>
<div style={{ display:"flex", justifyContent:"center" }}>
         <Lottie 
      animationData={stethoscopeAnim} 
      style={{ height: 70, width: 70, background:"transparent" }} 
    />
  </div>
          <p>Surgical Items</p>
        </div>

        
<div
  style={styles.card}
  onClick={() => navigate("/products/Health%20supplements")}
  onMouseEnter={(e)=>e.currentTarget.style.transform="scale(1.05)"}
  onMouseLeave={(e)=>e.currentTarget.style.transform="scale(1)"}
>
         <div style={{ display:"flex", justifyContent:"center" }}>
         <Lottie 
      animationData={supplementAnim} 
      style={{ height: 70, width: 70, background:"transparent" }} 
    />
  </div>
          <p>Supplements</p>
        </div>

       
<div
  style={styles.card}
  onClick={() => navigate("/products/Intimate%20care")}
  onMouseEnter={(e)=>e.currentTarget.style.transform="scale(1.05)"}
  onMouseLeave={(e)=>e.currentTarget.style.transform="scale(1)"}
>
          <div style={{ display:"flex", justifyContent:"center" }}>
         <Lottie 
      animationData={heartAnim} 
      style={{ height: 70, width: 70, background:"transparent" }} 
    />
  </div>
          <p>Intimate Care</p>
        </div>

        
<div
  style={styles.card}
  onClick={() => navigate("/products/Skin%20and%20hair%20Products")}
  onMouseEnter={(e)=>e.currentTarget.style.transform="scale(1.05)"}
  onMouseLeave={(e)=>e.currentTarget.style.transform="scale(1)"}
>
         <div style={{ display:"flex", justifyContent:"center" }}>
         <Lottie 
      animationData={beautyAnim} 
      style={{ height: 70, width: 70, background:"transparent" }} 
    />
  </div>
          <p>Hair & Skin</p>
        </div>


<div
  style={styles.card}
  onMouseEnter={(e)=>e.currentTarget.style.transform="scale(1.05)"}
  onMouseLeave={(e)=>e.currentTarget.style.transform="scale(1)"}
>
  <div style={{ display:"flex", justifyContent:"center" }}>
    <Lottie
      animationData={comingSoonAnim}
      style={{
        height: 70,
        width: 70,
        background:"transparent"
      }}
    />
  </div>

  <p>More Categories Coming Soon</p>
</div>
      </div>

      {/* HELP SECTION */}
<div style={styles.helpBox}>

  {/* General Support */}
  <a href="tel:6395050131" style={styles.contactCard}>
    <div style={styles.iconCircle}>
      <BsHeadset size={24} />
    </div>

    <div
  style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }}
>
      <div style={styles.contactTitle}>
        General Support
      </div>

      <div style={styles.contactNumber}>
        6395050131
      </div>
    </div>
  </a>

  {/* Pharmacist */}
  <a href="tel:8791600194" style={styles.contactCard}>
    <div style={styles.iconCircle}>
      <FaUserDoctor size={24} />
    </div>

    <div
  style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }}
>
      <div style={styles.contactTitle}>
        Pharmacist Helpline
      </div>

      <div style={styles.contactNumber}>
        8791600194
      </div>
    </div>
  </a>

</div>

      {/* FOOTER */}
    



    </div>
  );
}

// ================= STYLES =================

const styles = {
page: {
  minHeight: "100vh",
  padding: 16,

  paddingTop: "calc(20px + env(safe-area-inset-top))",   // 🔥 FIX TOP
  paddingBottom: "calc(90px + env(safe-area-inset-bottom))", // 🔥 FIX BOTTOM

background: "linear-gradient(135deg, #f5f7fb, #e4ecf7)",
color: "#111",
  fontFamily: "system-ui"
},

header: {
  display: "flex",
background: "transparent",
color: "#111",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 20,
  marginTop: 10   // 🔥 small push down
},
menuItem:{
  padding:"10px 12px",
  borderRadius:8,
  cursor:"pointer",
  transition:"0.3s",
},
  avatar: {
    width: 45,
    height: 45,
    borderRadius: "50%",
    background: "#ddd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  welcome: {
    fontSize: 12,
    color: "#888",
    margin: 0
  },

  name: {
    margin: 0,
    fontWeight: "bold"
  },

  icon: {
    background: "#eee",
    padding: 10,
    borderRadius: 10,
    cursor: "pointer",
    position: "relative"
  },

  badge: {
    position: "absolute",
    top: -5,
    right: -5,
    background: "red",
    color: "#fff",
    borderRadius: "50%",
    fontSize: 10,
    padding: "2px 6px"
  },


  badges: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginTop: 10
  },

  location: {
    marginTop: 10,
    background: "#eef3ff",
    padding: 10,
    borderRadius: 10
  },

banner: {
  background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 60%, #0f172a 100%)",
  color: "#fff",
  padding: 24,
  borderRadius: 20,
  marginBottom: 20,
  cursor: "pointer",
  boxShadow: "0 8px 25px rgba(37,99,235,0.35)"
},
  bannerBtn: {
    marginTop: 10,
    background: "#fff",
    color: "#2e7dff",
    border: "none",
    padding: "10px 16px",
    borderRadius: 12,
    fontWeight: "bold"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: 15,
    marginBottom: 20
  },

  card: {
    background: "rgba(255,255,255,0.9)",
backdropFilter: "blur(10px)",
    padding: 20,
    borderRadius: 18,
    textAlign: "center",
color:"#111",
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    cursor: "pointer",
transition:"0.3s ease"
  },
helpBox: {
  display: "flex",
  flexDirection: "column",
  gap: 12,
},

contactCard: {
  display: "flex",
  alignItems: "center",
justifyContent: "center",
  gap: 18,
  padding: 20,
  textDecoration: "none",
  background: "#fff",
  borderRadius: 18,
  color: "#111",
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
},
iconCircle: {
  width: 50,
  height: 50,
  borderRadius: "50%",
  background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  flexShrink: 0,
},

contactTitle: {
  fontSize: 14,
  color: "#64748b",
  fontWeight: 600,
},

contactNumber: {
  fontSize: 20,
  fontWeight: 700,
  color: "#2563eb",
},




  callCard: {
    display: "block",
    marginTop: 10,
    padding: 10,
    background: "#f5f7fb",
    borderRadius: 10,
    textDecoration: "none",
    color: "#000"
  },

  emergency: {
    display: "block",
    marginTop: 15,
    background: "#e53935",
    color: "#fff",
    padding: 12,
    borderRadius: 12,
    textAlign: "center",
    textDecoration: "none"
  },
icon: {
  width: "22px",          // 🔥 fix alignment
  display: "inline-block",
  textAlign: "center",
},
  footer: {
    textAlign: "center",
    fontSize: 13,
    color: "#666",
    marginBottom: 20
  },
menuIcon:{
  fontSize:22,
  cursor:"pointer",
},

overlay:{
  position:"fixed",
  top:0,
  left:0,
  right:0,
  bottom:0,
  background:"rgba(0,0,0,0.5)",
  zIndex:2000,
},

drawer:{
  position:"absolute",
  top:0,
  left:0,
  width:250,
  height:"100%",
  background:"#0f172a",
  padding:"20px 15px",
  display:"flex",
  flexDirection:"column",
  gap:18,
  color:"#fff",
  boxShadow:"5px 0 20px rgba(0,0,0,0.5)",
},
bottomNav: {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,

  height: "calc(65px + env(safe-area-inset-bottom))", // 🔥 FIX

  paddingBottom: "env(safe-area-inset-bottom)",       // 🔥 FIX

  background: "#fff",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  borderTop: "1px solid #eee",
  zIndex: 1000,
  boxShadow: "0 -2px 10px rgba(0,0,0,0.08)"
},
cardText:{
  marginTop:10,
  fontSize:15,
  fontWeight:"600",
},
  navLink: {
    textDecoration: "none",
    fontSize: 18
  },
badge: {
  position: "absolute",
  top: -2,        // 👈 change
  right: -2,      // 👈 change
  transform: "translate(30%, -30%)", // 👈 smooth corner positioning
  background: "red",
  color: "white",
  borderRadius: "50%",
  padding: "2px 6px",
  fontSize: 12,
  fontWeight: "bold",
}
};

export default CustomerDashboard;